import { render, staticRenderFns } from "./ProductCountHistory.vue?vue&type=template&id=1e20d70d&scoped=true"
import script from "./ProductCountHistory.vue?vue&type=script&lang=js"
export * from "./ProductCountHistory.vue?vue&type=script&lang=js"
import style0 from "./ProductCountHistory.vue?vue&type=style&index=0&id=1e20d70d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e20d70d",
  null
  
)

export default component.exports